import theme from '@gameday/react-components/utils/theme'

import { auth, formData, formSettings } from '../constants/actions'

const initialState = {
  bgGradientPrimaryColor: '',
  bgGradientSecondaryColor: '',
  buttonColour: '',
  buttonTextColour: '',
  formId: null,
  formName: '',
  formTitle: '',
  headerBackgroundColour: '',
  headerColour: '',
  orgLogo: null,
  headerTextColour: '',
  headingTextColour: '',
  textLinkColour: theme.colors.teal,
  landingPageImage: null,
  landingPageLogo: null,
  landingPageLink: '',
  organisationId: null,
  organisationName: '',
  progressBarColour: '',
  signoutButtonColour: '',
  eventName: '',
  eventLogo: null,
  formError: false,
  guestRegistration: false,
  memberOnly: false,
  soldOut: '',
  formType: null,
  paymentGateway: [],
  subdomain: null,
  eventType: '',
  generateEventEntryPass: false,
  generateEventTicket: false,
  insuranceResetKey: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case formSettings.SET_FORM_SETTINGS: {
      const payload = action.payload || {}
      const newState = { ...state }

      // Only update properties that are actually provided in the payload
      if (Object.hasOwn(payload, 'activationDate')) newState.activationDate = payload.activationDate
      if (Object.hasOwn(payload, 'bgGradientPrimaryColor'))
        newState.bgGradientPrimaryColor = payload.bgGradientPrimaryColor
      if (Object.hasOwn(payload, 'bgGradientSecondaryColor'))
        newState.bgGradientSecondaryColor = payload.bgGradientSecondaryColor
      if (Object.hasOwn(payload, 'expiryDate')) newState.expiryDate = payload.expiryDate
      if (Object.hasOwn(payload, 'status')) newState.status = payload.status
      if (Object.hasOwn(payload, 'timezone')) newState.timezone = payload.timezone
      if (Object.hasOwn(payload, 'buttonColour')) newState.buttonColour = payload.buttonColour
      if (Object.hasOwn(payload, 'buttonTextColour')) newState.buttonTextColour = payload.buttonTextColour
      if (Object.hasOwn(payload, 'formId')) newState.formId = payload.formId
      if (Object.hasOwn(payload, 'formName')) newState.formName = payload.formName
      if (Object.hasOwn(payload, 'formTitle')) newState.formTitle = payload.formTitle
      if (Object.hasOwn(payload, 'headerBackgroundColour'))
        newState.headerBackgroundColour = payload.headerBackgroundColour
      if (Object.hasOwn(payload, 'headerColour')) newState.headerColour = payload.headerColour
      if (Object.hasOwn(payload, 'orgLogo')) newState.orgLogo = payload.orgLogo
      if (Object.hasOwn(payload, 'headerTextColour')) newState.headerTextColour = payload.headerTextColour
      if (Object.hasOwn(payload, 'headingTextColour')) newState.headingTextColour = payload.headingTextColour
      if (Object.hasOwn(payload, 'landingPageImage')) newState.landingPageImage = payload.landingPageImage
      if (Object.hasOwn(payload, 'landingPageLogo')) newState.landingPageLogo = payload.landingPageLogo
      if (Object.hasOwn(payload, 'landingPageLink')) newState.landingPageLink = payload.landingPageLink
      if (Object.hasOwn(payload, 'organisationId')) newState.organisationId = payload.organisationId
      if (Object.hasOwn(payload, 'organisationName')) newState.organisationName = payload.organisationName
      if (Object.hasOwn(payload, 'progressBarColour')) newState.progressBarColour = payload.progressBarColour
      if (Object.hasOwn(payload, 'signoutButtonColour')) newState.signoutButtonColour = payload.signoutButtonColour
      if (Object.hasOwn(payload, 'eventName')) newState.eventName = payload.eventName
      if (Object.hasOwn(payload, 'eventLogo')) newState.eventLogo = payload.eventLogo
      if (Object.hasOwn(payload, 'guestRegistration')) newState.guestRegistration = payload.guestRegistration
      if (Object.hasOwn(payload, 'memberOnly')) newState.memberOnly = payload.memberOnly
      if (Object.hasOwn(payload, 'soldOut')) newState.soldOut = payload.soldOut
      if (Object.hasOwn(payload, 'type')) newState.formType = payload.type
      if (Object.hasOwn(payload, 'paymentGateway')) newState.paymentGateway = payload.paymentGateway
      if (Object.hasOwn(payload, 'eventType')) newState.eventType = payload.eventType
      if (Object.hasOwn(payload, 'generateEventEntryPass'))
        newState.generateEventEntryPass = payload.generateEventEntryPass
      if (Object.hasOwn(payload, 'generateEventTicket')) newState.generateEventTicket = payload.generateEventTicket
      if (Object.hasOwn(payload, 'allowOnlyOneMemberType'))
        newState.allowOnlyOneMemberType = payload.allowOnlyOneMemberType
      if (Object.hasOwn(payload, 'teamActivationDate')) newState.teamActivationDate = payload.teamActivationDate
      if (Object.hasOwn(payload, 'teamExpiryDate')) newState.teamExpiryDate = payload.teamExpiryDate
      if (Object.hasOwn(payload, 'currentTime')) newState.currentTime = payload.currentTime

      // Handle textLinkColour with default
      newState.textLinkColour = payload.textLinkColour || theme.colors.teal

      // Add any additional properties from payload
      Object.keys(payload).forEach(key => {
        if (!Object.hasOwn(newState, key) && key !== 'type') {
          newState[key] = payload[key]
        }
      })

      return newState
    }
    case formSettings.GET_FORM_SETTINGS_ERROR: {
      return {
        ...state,
        formError: true,
      }
    }
    case formSettings.SET_FORM_SUBDOMAIN: {
      const { subdomain } = action.payload

      return {
        ...state,
        subdomain,
      }
    }
    case formData.RESET_FORM:
    case auth.SIGN_OUT:
    case formSettings.RESET_INSURANCE:
      return {
        ...state,
        insuranceResetKey: state.insuranceResetKey + 1,
      }
    default:
      return state
  }
}
